import React from 'react'
import { useSelector } from 'react-redux'
import Actions from './Actions'
// import FavPages from './FavPages'
// import IssuesHistory from './IssuesHistory'
// import LanguageSwitcher from './LanguageSwitcher'
// import ProjectManagement from './ProjectManagement'
// import Search from './Search'
import style from './style.module.scss'
import UserMenu from './UserMenu'

const TopBar = () => {
  const businessName = useSelector(state => state.user.businessName)
  return (
    <div className={style.topbar}>
       <div className="mr-4">
        {/* <FavPages /> */}
        <h4 >{businessName}</h4>
      </div> 
      <div className="mr-auto">
        {/* <Search /> */}
      </div>
      <div className="mr-4 d-none d-md-block">
        {/* <IssuesHistory /> */}
      </div>
      <div className="mb-0 mr-auto d-xl-block d-none">
        {/* <ProjectManagement /> */}
      </div> 
       <div className="mr-4 d-none d-sm-block">
        {/* <LanguageSwitcher/> */}
      </div> 
      <div className="mr-4 ml-auto ">
        <Actions />
      </div>
      <div className="">
        <UserMenu />
      </div>
    </div>
  )
}

export default TopBar
